/** Tab-local authentication. This module must not import the app, HTTP or the session runtime (`@/auth`). */
const markerKey = 'srm.support.isolated';
const sessionKey = 'srm.support.session';
const entryPath = /\/support\/session\/?$/.test(window.location.pathname);
let ticket = entryPath ? new URLSearchParams(window.location.hash.slice(1)).get('ticket') : null;

export interface ISupportSession {
    accessToken: string;
    userId: string;
    userName: string;
    actorName: string;
    expiresAt: string;
    /** Сеанс поддержки (`support_case`); нет у входов, открытых до журнала сеансов */
    caseId?: string;
    /** Номер обращения, если сотрудник его указал */
    ticketRef?: string | null;
    /** Причина входа */
    reason?: string;
}

let isolated = entryPath;
let session: ISupportSession | null = null;
try {
    isolated ||= sessionStorage.getItem(markerKey) === 'true';
    if (entryPath) sessionStorage.setItem(markerKey, 'true');
    if (ticket) sessionStorage.removeItem(sessionKey);
    const stored = sessionStorage.getItem(sessionKey);
    if (isolated && stored) {
        const parsed = JSON.parse(stored) as ISupportSession;
        if (
            typeof parsed.accessToken === 'string' &&
            typeof parsed.userName === 'string' &&
            Number.isFinite(Date.parse(parsed.expiresAt)) &&
            Date.parse(parsed.expiresAt) > Date.now()
        )
            session = parsed;
    }
} catch {
    // Fail closed in the entry tab; never fall back to the administrator's localStorage/cookie.
}
if (ticket) history.replaceState(history.state, '', window.location.pathname + window.location.search);

/**
 * Вкладка «от имени» пульсирует и в фоне: по пульсу сервер держит вход открытым (без него через 10 мин — `idle`).
 * 30 с — с запасом против троттлинга таймеров фоновой вкладки (не реже раза в минуту).
 */
export const SUPPORT_HIDDEN_BEAT_INTERVAL_MS = 30_000;

const listeners = new Set<() => void>();
export const isSupportSession = (): boolean => isolated;
export const getSupportSession = (): ISupportSession | null => session;
export const takeSupportTicket = (): string | null => {
    const value = ticket;
    ticket = null;
    return value;
};
export const subscribeSupportSession = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
export function saveSupportSession(value: ISupportSession): void {
    if (!isolated) throw new Error('Это не вкладка изолированного входа.');
    // Storage is required: without it reload could restore the ordinary session.
    sessionStorage.setItem(markerKey, 'true');
    sessionStorage.setItem(sessionKey, JSON.stringify(value));
    session = value;
    listeners.forEach((listener) => listener());
}
export function clearSupportSession(): void {
    session = null;
    try {
        sessionStorage.removeItem(sessionKey);
    } catch {
        /* Keep the isolation marker. */
    }
    listeners.forEach((listener) => listener());
}
